import React, { useState } from 'react';
import { Button } from 'antd';
import cn from 'classnames';
import { useMeasure } from '../../../../../hooks/useMeasure';
import styles from './ListCellContent.module.scss';

const maxSize = 2;

const ListCellContent = ({ className, items, renderItem }) => {
  const [ref, { width }] = useMeasure();
  const [showAll, setShowAll] = useState(false);

  const itemsToRender = showAll ? items ?? [] : (items ?? []).slice(0, maxSize);

  return (
    <ul
      className={cn(styles.root, className)}
      ref={ref}
    >
      {itemsToRender.map((item, index) => (
        <li
          key={item.id ?? index}
          className={styles.item}
        >
          {renderItem({ item, parentWidth: width })}
        </li>
      ))}
      {items.length > maxSize && (
        <li>
          <Button
            type="link"
            className={styles.toggleItemsBtn}
            onClick={(e) => {
              e.stopPropagation();
              setShowAll((prev) => !prev);
            }}
          >
            {showAll ? 'Скрыть' : `+ еще ${items.length - maxSize}`}
          </Button>
        </li>
      )}
    </ul>
  );
};

export default ListCellContent;
